/**
 * 聚合字典api接口
 * @author： xuyd
 * @date：2022-01-12
 * Copyright (c) 2022 fxwiz all rights reserved.
 */
import request from "@/utils/request.js"

import {context} from '@/config/env.js'
const serviceModule = context.sunflower

export default {

  /**
   * 聚合接口：自定义下拉字典（和字典接口一致）：ftp服务器/输出频率/...
   *
   * @param dictTypes ['CON','TYPE']
   */
  selectMapCustomDict: (dictTypes) => {
    return request.post(serviceModule + "/agg/dict/selectMapCustomDict", dictTypes);
  },

}
